// Tooltip delays (in milliseconds)
export const TOOLTIP_OPEN_DELAY_DEFAULT = 800;

// Pagination
export const SLACK_PAGE_LIMIT = 3000;
export const DOBOX_PAGE_LIMIT = 10;
export const DOBOX_RESOLVED_PAGE_LIMIT = 20;
export const DOBOX_RECURRENCES_PAGE_LIMIT = 20;
export const COMMENTS_PAGE_LIMIT = 20;
export const LINKED_TASK_PICKER_PAGE_LIMIT = 25;
export const ACTIVITY_LOGS_PAGE_LIMIT = 20;
export const INBOX_FEATURES_LIMIT = 30;
export const NOTIFICATIONS_PAGINATION_LIMIT = 50;
// Component sizes
export const MIN_SELECTION_COUNT_WIDTH = 70;
export const DEFAULT_MOBILE_ALERT_TOP_OFFSET = 65;

// Z-index layers
export const Z_INDEX_POPOVER = 1500;
// Overlay/content of a modal opened from inside another modal — must beat the
// app's load-bearing z-index:1500 overlay rule (see modal_stacking memory).
export const Z_INDEX_NESTED_MODAL_OVERLAY = 2050;
// Nested modal depth tiers, level 1..3 (deeper clamps to 3). Must stay below
// Z_INDEX_MODAL_DROPDOWN (2150) so dropdowns render above every modal level.
export const NESTED_MODAL_Z_LEVELS = [
  { overlay: Z_INDEX_NESTED_MODAL_OVERLAY, container: 2100 },
  { overlay: 2110, container: 2120 },
  { overlay: 2130, container: 2140 },
] as const;
// Dropdown portalled out of a scrolling modal body — must beat the global
// .chakra-modal__content-container rules (1900, and 2100 when nested).
export const Z_INDEX_MODAL_DROPDOWN = 2150;
export const Z_INDEX_MOBILE_SHEET = 9999; // mirrors z-[9999] Tailwind arbitrary class used by mobile sheet/popover stylesheets
export const Z_INDEX_MODAL_ABOVE_SHEET = 10000;
export const Z_INDEX_DOCK_OVERLAY = 1380;

// Visibility
export const VISIBILITY_VISIBLE = 'visible' as const;
export const VISIBILITY_HIDDEN = 'hidden' as const;

export const getPopoverVisibility = (isReady: boolean) =>
  isReady ? VISIBILITY_VISIBLE : VISIBILITY_HIDDEN;

// Spinner sizes
export const SPINNER_SIZE_MD = 'md';
export const SPINNER_SIZE_XS = 'xs';

// Spinner variants
export const SPINNER_VARIANT_EMERALD = 'emerald';

// Modal sizes (Chakra size tokens)
export const MODAL_SIZE_FULL = 'full';
export const MODAL_SIZE_3XL = '3xl';
export const MODAL_SIZE_4XL = '4xl';
export const MODAL_SIZE_6XL = '6xl';

// Animation/Transition durations (in milliseconds)
export const DEFAULT_ANIMATION_DURATION = 300;
export const LOADING_SPINNER_DELAY = 200;

// Form validation
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_TEXTAREA_LENGTH = 500;

// Toast/Notification durations (in milliseconds)
export const SUCCESS_TOAST_DURATION = 3000;
export const ERROR_TOAST_DURATION = 5000;
export const WARNING_TOAST_DURATION = 4000;

// Text separators
export const ACTION_SEPARATOR = '\u00B7';

// Communication card body preview truncation
export const COMMUNICATION_BODY_PREVIEW_CHAR_LIMIT = 220;

// file attachment size limit
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

// Apollo fetch policies
export const FETCH_POLICY_CACHE_FIRST = 'cache-first' as const;
export const FETCH_POLICY_CACHE_AND_NETWORK = 'cache-and-network' as const;
export const FETCH_POLICY_NETWORK_ONLY = 'network-only' as const;
export const FETCH_POLICY_NO_CACHE = 'no-cache' as const;

// How long the "Checklist deleted — Undo" strip stays before the delete actually fires.
// The mutation is deferred for this window rather than issued and reversed, because
// re-creating would mint a new checklist id and lose every subtask with it.
export const CHECKLIST_DELETE_UNDO_MS = 6000;
// Past this many items, per-item progress segments become unreadable hairlines; the bar
// switches to two proportional segments (done / remaining).
export const MAX_CHECKLIST_PROGRESS_SEGMENTS = 16;

// Coalesces a burst of chat reply-state frames for the open DoBox task into one detail refetch.
export const ENTRY_CHAT_ACTIVITY_REFETCH_DEBOUNCE_MS = 1000;
